import React from "react";
import { Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import styles from "../../artistSeeAll/ArtistSeeAll.module.css";

const MusicArtistListLoading = () => {
  const theme = useTheme();

  const skeletonItems = Array.from({ length: 20 }, (_, index) => (
    <div key={index} className={`inline truncate text-center`}>
      <Skeleton
        variant="square"
        width={90}
        height={90}
        sx={{
          borderRadius: "50%",
          backgroundColor: theme.palette.background.paper,
        }}
      />

      <span className="text-xs mt-2">
        <Skeleton
          variant="text"
          width={70}
          height={30}
          sx={{
            backgroundColor: theme.palette.background.paper,
            marginX: "auto",
          }}
        />
      </span>
    </div>
  ));

  return (
    <div
      className={`grid`}
      style={{
        gridTemplateColumns: "repeat(auto-fit, minmax(5rem, 1fr))",
        gap: "2rem",
      }}
    >
      {skeletonItems}
    </div>
  );
};

export default MusicArtistListLoading;
